var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'is-focus-key': _vm.isKeyboardFocussed},attrs:{"id":"app"}},[_c('router-view'),_c('SvgSprites')],1)}
var staticRenderFns = []

export { render, staticRenderFns }